"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
const EventRecorder_1 = __importDefault(require("../EventRecorder"));
const SegmentEventRecorder_1 = require("../EventRecorder/SegmentEventRecorder");
class Analytics {
    constructor(options) {
        this.options = options;
        this.destinations = [
        // new CademyEventRecorder(options.baseUrl, new Request(), options.recordAgainst),
        ];
        if (options.segmentApiKey) {
            this.destinations.push(new SegmentEventRecorder_1.SegmentEventRecorder({
                apiKey: options.segmentApiKey,
                recordedOn: options.recordAgainst,
            }));
        }
        this.record = new EventRecorder_1.default(this.destinations);
    }
}
exports.Analytics = Analytics;
exports.default = Analytics;
